// Maps the reactive project criteria onto the /web-api/projects/search
// querystring (ProjectSearchRequestFactory owns the server side). Location is
// sent as long/lat + radius, but only when coordinates are known; bbox comes
// from the map viewport and wins over the radius server-side.

export const toProjectsApiParams = (criteria, page = 1, bbox = null) => {
  const params = new URLSearchParams();

  if (page > 1) params.set('page', String(page));

  if (criteria.long !== null && criteria.lat !== null) {
    params.set('long', String(criteria.long));
    params.set('lat', String(criteria.lat));
    if (criteria.radius !== null) params.set('radius', String(criteria.radius));
  }

  // Rounded so the watched querystring stays stable across float noise
  if (bbox) params.set('bbox', bbox.map((value) => value.toFixed(6)).join(','));

  if (criteria.regions.length) params.set('regions', criteria.regions.join(','));
  if (criteria.statuses.length) params.set('statuses', criteria.statuses.join(','));

  params.set('sort', criteria.sort);

  return params;
};
